<template>
  <div class="env-chart">
    <div class="top-left-side"></div>
    <div class="bottom-left-side"></div>
    <div class="top-right-side"></div>
    <div class="bottom-right-side"></div>
    <!-- 加载中 -->
    <Spin class="loading" v-show="loading">
      <div class="loading-container">
        <Icon class="demo-spin-icon-load" type="ios-loading" size="18" />
        <div class="loading-text">加载中</div>
      </div>
    </Spin>
    <!-- 为空 -->
    <div class="empty" v-show="empty">
      当前站点 / 园区暂无传感器
    </div>
    <!-- 图表 -->
    <div id="chart"></div>
  </div>
</template>

<script>
const echarts = require("echarts");
import { mapActions } from "vuex";
import localStore from "../utils/localStorge";

export default {
  name: "env-chart",
  data() {
    return {
      loading: true,
      empty: false,
      chart: null
    };
  },
  async mounted() {
    // 初始化DOM元素
    this.chart = echarts.init(document.getElementById("chart"));
    // 获取温室列表信息
    await this.roomList();
    await this.envChartMessage({
      id: this.$store.state.roomId
    })
      .then(res => {
        let name = [];
        let date = [];
        let data = [];
        if (res.length === 0) {
          this.loading = false;
          this.empty = true;
          return;
        }
        for (let k = 0; k < res[0].data.length; k++) {
          date.push(res[0].data[k].time.slice(5, 10) + " " + res[0].data[k].time.slice(11, 16));
        }
        for (let i = 0; i < res.length; ++i) {
          name.push(res[i].name + res[i].number);
          let oneWeekData = [];
          for (let j = 0; j < res[i].data.length; ++j) {
            oneWeekData.push(res[i].data[j].mean_number.toFixed(2));
          }
          data.push({
            name: res[i].name + res[i].number,
            data: oneWeekData,
            type: "line",
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00e3ff"
                  },
                  {
                    offset: 1,
                    color: "#002756"
                  }
                ])
              }
            }
          });
        }
        // 关闭加载动画
        this.loading = false;
        this.empty = false;
        this.setChart(name, date, data);
      })
      .catch(error => {
        console.error(error);
        this.empty = true;
        this.loading = false;
      });
  },
  methods: {
    ...mapActions("envChart", ["envChartMessage"]),
    ...mapActions(["roomList"]),
    setChart(name, date, data) {
      // 设置默认选中的只有第一项
      let selected = {};
      let firstShow = false;
      if (localStore.get("envChartSelect") === null) {
        for (let i = 0; i < name.length; i++) {
          if (data[i].data.length !== 0 && !firstShow) {
            firstShow = true;
            selected[name[i]] = firstShow;
          } else {
            selected[name[i]] = false;
          }
        }
      } else {
        selected = localStore.get("envChartSelect");
      }
      let options = {
          title: {
            show: true,
            text: "环境趋势一览",
            textStyle: {
              color: "#FFFFFF"
            },
            top: "6%",
            left: "center",
            fontSize: "24"
          },
          color: ["#00e3ff", "#fff100", "#8957a1"],
          grid: {
            top: "20%",
            bottom: "14%",
            left: "4%",
            right: "4%",
            containLabel: true
          },
          legend:Object.assign({},{
            type: 'scroll',
            data: name,
            selectedMode: true,
            padding: [5,0,0,0],
            x: "center",
            y: "90%",
            textStyle: {
              color: "#FFFFFF"
            },
            icon: "circle",
            inactiveColor: "#CCCCCC"
          },!this.logIsShowMarkder?{
						selected: selected,
					}:{}),
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            },
            data: date
          },
          yAxis: {
            type: "value",
            axisLabel: {
              textStyle: {
                color: "#fff"
              }
            }
          },
          series: data
      };
      this.chart.setOption(options);
      window.addEventListener("resize", this.resizeChart);
      // 解除上一个绑定事件在重新绑定事件，防止重复执行两次
      this.chart.off("legendselectchanged");
      this.chart.on("legendselectchanged", (params) => {
        localStore.set("envChartSelect", params.selected);
      });
    },
    resizeChart() {
      this.chart.resize();
    }
  },
  watch: {
    "$store.state.roomId": async function (newValue) {
      // console.log(newValue);
      this.loading = true;
      this.empty = false;
      this.chart.clear();
      await this.envChartMessage({
        id: newValue
      })
        .then(res => {
          // console.log(res);
          let name = [];
          let date = [];
          let data = [];
          // 判断长度为0时
          if (res.length === 0) {
            this.loading = false;
            this.empty = true;
            return;
          }
          // 获取日期（date）
          for (let k = 0; k < res[0].data.length; k++) {
            date.push(res[0].data[k].time.slice(5, 10) + " " + res[0].data[k].time.slice(11, 16));
          }
          // 获取类别（name）和数据（data）
          for (let i = 0; i < res.length; ++i) {
            name.push(res[i].name);
            let oneWeekData = [];
            for (let j = 0; j < res[i].data.length; ++j) {
              oneWeekData.push(res[i].data[j].mean_number.toFixed(2));
            }
            data.push({
              name: res[i].name,
              data: oneWeekData,
              type: "line",
              areaStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {
                      offset: 0,
                      color: "#00e3ff"
                    },
                    {
                      offset: 1,
                      color: "#002756"
                    }
                  ])
                }
              }
            });
          }
          // 关闭加载动画
          this.loading = false;
          this.empty = false;
          this.setChart(name, date, data);
        })
        .catch(error => {
          console.error(error);
          this.empty = true;
          this.loading = false;
        });
      this.loading = false;
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeChart);
  }
};
</script>

<style scoped>
.env-chart {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  height: calc((100% - 80px) / 3);
  width: calc(100% - 53.23vw - 80px);
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.5vw;
  border: 1px solid #036fc2;
}

.top-left-side {
  position: absolute;
  top: -1px;
  left: -1px;
  width: 1vw;
  height: 1vw;
  border-top: 3px solid #ffffff;
  border-left: 3px solid #ffffff;
  border-top-left-radius: 0.5vw;
}

.bottom-left-side {
  position: absolute;
  bottom: -1px;
  left: -1px;
  width: 1vw;
  height: 1vw;
  border-bottom: 3px solid #ffffff;
  border-left: 3px solid #ffffff;
  border-bottom-left-radius: 0.5vw;
}

.top-right-side {
  position: absolute;
  top: -1px;
  right: -1px;
  width: 1vw;
  height: 1vw;
  border-top: 3px solid #ffffff;
  border-right: 3px solid #ffffff;
  border-top-right-radius: 0.5vw;
}

.bottom-right-side {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 1vw;
  height: 1vw;
  border-bottom: 3px solid #ffffff;
  border-right: 3px solid #ffffff;
  border-bottom-right-radius: 0.5vw;
}

#chart {
  position: relative;
  height: 100%;
  width: 100%;
}

.empty {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6vw;
  background-color: rgba(255, 255, 255, 0.15);
  z-index: 3;
}

.loading {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 4;
}

.loading-container {
  display: flex;
  align-items: center;
}

.loading-text {
  font-size: 0.6vw;
  padding-left: 0.2vw;
}
</style>
